import React from 'react';
import ReactDOM from 'react-dom';
import { Route, HashRouter} from 'react-router-dom'
import { Provider } from "react-redux";
import './css/style.css';
import store from './store';
import Webservers from './pages/webservers';
import ManipulationTool from './pages/manipulationTool';
import HybridIonTreatment from './pages/hybridIonTreatment';
import PHDependencyOfEnergy from './pages/phDependencyOfEnergy';
import NavBar from './components/navBar';
import Footer from './components/footer';
import Flexibility from './pages/flexibility';
import HybridIonTreatmentV2 from './pages/hybridIonTreatmentV2';

import reportWebVitals from './reportWebVitals';

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );
//
//
////
//////<Route exact path="/hitV2" component={HybridIonTreatmentV2} />
const router = (
    <Provider store={store}>
          <HashRouter >
            <NavBar/>
            <Route exact path="/" component={Webservers} />
            <Route exact path="/manipulationTool" component={ManipulationTool} />
            <Route exact path="/hit" component={HybridIonTreatment} />
            <Route exact path="/phDependencyOfEnergy" component={PHDependencyOfEnergy} />
            <Route exact path="/software" component={PHDependencyOfEnergy} />
            <Route exact path="/flexibility" component={Flexibility} />
            <Route exact path="/hitV2" component={HybridIonTreatmentV2} />

            <Footer/>
          </HashRouter>
    </Provider>
);



ReactDOM.render(router, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



// WEBPACK FOOTER //
// ./src/index.js